/**
 * Interruptor "Dados ficticios". Ligado: dados ficticios, so leitura. Desligado: o
 * que foi cadastrado neste aparelho. Os dois nunca se misturam — trocar
 * recarrega o app com a outra fonte.
 *
 * Preferencia do aparelho (localStorage): e conveniencia, nao dado.
 */
const CHAVE = 'equiview.modo';

export type Modo = 'demo' | 'real';

export function lerModo(): Modo {
  try {
    return localStorage.getItem(CHAVE) === 'real' ? 'real' : 'demo';
  } catch {
    return 'demo';
  }
}

export function trocarModo(modo: Modo) {
  try {
    localStorage.setItem(CHAVE, modo);
  } catch {
    // Sem armazenamento, a troca nao persiste; o recarregamento volta ao padrao.
  }
  window.location.assign('/animais');
}
